import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
// import { modalConfig } from './config/modal.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { ref } from 'vue'
// import { usePageModal } from '@/hooks/usePageModal'
//
// const otherInfo = ref({})
//
// const modalTitle = ref('新增')

// const newCb = () => {
//   modalTitle.value = '新增项目'
// }
//
// const editCb = () => {
//   modalTitle.value = '编辑项目'
// }


export default /*#__PURE__*/_defineComponent({
  __name: 'CustGroupQuery',
  setup(__props) {

const queryParam = {
  unionId: ''
}
const resetCb = () => {
  return queryParam
}
const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch(resetCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "custGroup"
    }, null, 8, ["contentTableConfig"])
  ]))
}
}

})